<div class="carSection">
  <div class="wrapper">
    <div class="car_form">
      <h3>Search over 150,000 AA-approved cars</h3>
      <form [formGroup]="usedCarModel" novalidate id="carsales">
        <div class="formItem select-container ">
          <label for="makeDropdown">Make</label>
          <select formControlName="make" (change)="onChangedMake($event)">
            <option [value]="-1" [selected]>Select make</option>
            @for (make of makes; track trackByFn($index)) {
              <option [value]="make.id">{{make.name}} </option>
            }
          </select>
        </div>
        <div class="formItem select-container ">
          <label for="modelDropdown">Model</label>
          <select formControlName="model">
            <option [value]="-1" [selected]>Select model</option>
            @for (model of models; track trackByFn($index)) {
              <option [value]="model.name">{{model.name}}</option>
            }
          </select>
        </div>
        <div class="formItem">
          <label for="postcode">Postcode</label>
          <input formControlName="postCode" maxlength="8" id="postcode">
        </div>
        <div class="formItem"><a class="search_button"><button class="btn primary"
        (click)="redirectToDisplayCars()">Search</button></a></div>
      </form>
    </div>
  </div>
</div>